//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import { SuperAgentStatic, SuperAgentRequest, Response } from 'superagent';
import {
  CallbackHandler,
  RequestHeadersHandler,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  Logger,
  RequestHeaders,
  QueryParameters,
  CommonRequestOptions,
  ResponseWithBody,
} from './types';

export type JToken = Array<JToken>;

export type LogInformation = {
  authorizationId?: string;
  calculationId?: string;
  calculationInputs?: {} & {
    [key: string]: JToken;
  };
  calculationOutputs?: {} & {
    [key: string]: JToken;
  };
  clientId?: string;
  createDate?: string;
  intermediateCalculations?: {} & {
    [key: string]: JToken;
  };
  modelId?: string;
  modelVersion?: number;
};

export type LogInformationArrayResponseWrapper = {
  data?: Array<LogInformation>;
};

export type QueryPayload = {
  authorizationIds?: Array<string>;
  calculationIds?: Array<string>;
  endDate?: string;
  modelIds?: Array<string>;
  startDate?: string;
};

/**
 * Insight2Profit CalculationLogging
 * @class CalculationLogService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class CalculationLogService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      req.send(body);

      if (typeof body === 'object' && !(body.constructor.name === 'Buffer')) {
        headers['Content-Type'] = 'application/json';
      }
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  /**
   *
   * @method
   * @name CalculationLogService#postLogClientsByClientIdCalculations
   * @description /log/clients/{clientId}/calculations
   * @param {string} clientId - Insight2Profit CalculationLogging
   * @param {} body - Insight2Profit CalculationLogging
   */
  postLogClientsByClientIdCalculations(
    parameters: {
      clientId: string;
      body?: QueryPayload;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, LogInformationArrayResponseWrapper>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/log/clients/{clientId}/calculations';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name CalculationLogService#postLogClientsByClientIdCalculationsInsert
   * @description /log/clients/{clientId}/calculations/insert
   * @param {string} clientId - Insight2Profit CalculationLogging
   * @param {integer} ttl - Insight2Profit CalculationLogging
   * @param {} body - Insight2Profit CalculationLogging
   */
  postLogClientsByClientIdCalculationsInsert(
    parameters: {
      clientId: string;
      ttl?: number;
      body?: LogInformation;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, LogInformationArrayResponseWrapper>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/log/clients/{clientId}/calculations/insert';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['ttl'] !== undefined) {
        queryParameters['ttl'] = parameters['ttl'];
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name CalculationLogService#getLogClientsByClientIdCalculationsById
   * @description /log/clients/{clientId}/calculations/{id}
   * @param {string} clientId - Insight2Profit CalculationLogging
   * @param {string} id - Insight2Profit CalculationLogging
   */
  getLogClientsByClientIdCalculationsById(
    parameters: {
      clientId: string;
      id: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, LogInformationArrayResponseWrapper>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/log/clients/{clientId}/calculations/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default CalculationLogService;
